import styled from '@emotion/styled';
import { mergeProps, useFocusRing } from 'react-aria';

import { su } from '../../../theme/functions/su';
import { theme } from '../../../theme/theme';

import { Glyph } from '../../../components/common/Glyph';
import { HomeyIcon } from '../../../components/common/HomeyIcon';
import { getButtonImage } from '../../../components/controls/button/getButtonImage';
import { getToggleImages } from '../../../components/controls/toggle/getToggleImages';
import { useOptionContext } from '../../../components/list-box/ListBox';

export function DeviceSettingsGeneralQuickActionOverrideIcon(props) {
  const capabilityObj = props.value?.capabilityObj ?? null;

  if (capabilityObj == null) {
    return null;
  }

  const image =
    props.value.actionType === 'toggle'
      ? getToggleImages(capabilityObj.id, capabilityObj)
      : getButtonImage(capabilityObj.id, capabilityObj);
  const source = props.value.actionType === 'toggle' ? image.urlFalse : image.url;

  return (
    <S.IconRoot aria-hidden={true}>
      {image.useIconObj === true ? (
        <HomeyIcon iconObj={image.iconObj} color="currentColor" size={theme.icon.size_small} />
      ) : source != null ? (
        <S.Icon source={source} color="currentColor" size={theme.icon.size_small} />
      ) : null}
    </S.IconRoot>
  );
}

export function DeviceSettingsGeneralQuickActionOverrideSelectOption() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars -- intentionally unused
  const { ref, option, state, item, value } = useOptionContext();

  const focusRing = useFocusRing();

  return (
    <S.Root
      {...mergeProps(option.optionProps, focusRing.focusProps)}
      ref={ref}
      data-is-selected={option.isSelected}
      data-is-focused={option.isFocused}
      data-is-pressed={option.isPressed}
      data-is-disabled={option.isDisabled}
      data-is-focus-visible={focusRing.isFocusVisible}
    >
      <S.Inner>
        <DeviceSettingsGeneralQuickActionOverrideIcon value={value} />
        <S.Name>{value.textValue}</S.Name>
      </S.Inner>
    </S.Root>
  );
}

function S() {}
DeviceSettingsGeneralQuickActionOverrideSelectOption.S = S;

S.Inner = styled.div`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  gap: ${su(1.5)};
  width: 100%;
  min-height: 48px;
  min-width: 0;
  text-decoration: none;
  color: inherit;
  padding: ${su(1)} 10px;
`;

S.IconRoot = styled.span`
  flex: 0 0 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  background-color: ${theme.color.mono_050};
  color: ${theme.color.mono_600};
`;

S.Icon = styled(Glyph)``;

S.Name = styled.div`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 20px;
`;

S.Root = styled.li`
  display: flex;
  position: relative;
  align-items: center;
  width: 100%;
  max-width: 100%;
  outline: 0;
  cursor: pointer;

  &[data-is-selected='true'] {
    ${S.Name} {
      color: ${theme.color.highlight};
      font-weight: ${theme.fontWeight.medium};
    }
  }

  &[data-is-focus-visible='true'] {
    background-color: ${theme.color.background_hover};
  }

  &:hover {
    background-color: ${theme.color.background_hover};

    &:not([data-is-selected='true']) {
      ${S.Name} {
        font-weight: ${theme.fontWeight.medium};
      }
    }
  }
`;
